<template>
  <v-card elevation="0">
    <ItemPicturesCarousel :item="item"/>
    <v-card-text class="py-5 px-4 px-md-8" ref="content">
      <div class="d-flex align-center justify-space-between mb-6 pa-4" style="position: absolute; top: 0; right: 0;">
        <v-btn @click="$emit('close')" color="white" small icon style="background: tomato">
          <v-icon size="18">mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="d-flex flex-column align-start fill-width mt-4">
        <div>{{ item.name }}</div>
      </div>

      <v-divider class="my-4"></v-divider>

      <div v-if="available" class="mt-3">
        <div>
          <div class="title font-weight-bold text--black">
            {{ plan.monthly | currency }} / mo
          </div>
          <div class="d-flex align-center">
            <div class="text-body-1 mt-1">
              {{ plan.duration }} installment(s)
            </div>
            <div class="text-body-1 font-weight-medium ma-0 mt-1 ml-2">
              + {{ plan.upfront | currency }} upfront
            </div>
          </div>
        </div>
        <v-divider class="my-4"></v-divider>
        <div class="d-flex mt-6">
          <v-btn @click="$emit('plans')" class="flex-grow-1 rounded-lg" color="primary" elevation="0">
            <v-icon class="mr-2">mdi-animation-outline</v-icon>
            View plans
          </v-btn>
        </div>
      </div>
      <v-chip v-else small class="mb-1">Not available</v-chip>

      <v-card class="px-8 py-6 mb-5 mt-5" outlined>
        <v-subheader class="px-0 text--secondary" style="height: initial" v-if="!item.description">
          No description
        </v-subheader>
        <div v-else>
          <v-subheader class="px-0 text--secondary mb-4" style="height: initial">Description</v-subheader>
          <div class="text-title black--text text--lighten-2 pre-wrap" v-html="item.description">
          </div>
        </div>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import ItemPicturesCarousel from "@/components/item/ItemPicturesCarousel.vue";
import item from "@/mixins/item.js";

export default {
  name: "ProductDetailsOther",
  components: { ItemPicturesCarousel },
  mixins: [item],
  created() {
    if (!`${ this.item.id }`.includes('temp')) this.addView();
  },
  methods: {
    requestPrice() {
      this.$store.commit('cart/addItem', {
        ...this.item,
        monthly_amount: 0,
        price: 0,
        credit_price: 0,
        unit: this.quantity
      });
      this.$bus.$emit('cart');
    },
    created() {
      this.addView();
    },
  }
}
</script>
